import {NgModule, Component, Injectable } from '@angular/core';
import { ucs2 } from 'punycode';
import { HttpClient,HttpHeaders} from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';


@Injectable()
export class HttpEngineService {

  baseUrl:string = "https://graph.facebook.com/";

  constructor(private http: HttpClient) {

  }

  FbGet(token: string, uid: string)
  {
    let promise = new Promise((resolve, reject) => {
      let apiURL = `${this.baseUrl}${uid}?access_token=${token}`;
      this.http.get(apiURL)
        .toPromise()
        .then(
          res => { // Success
            console.log(res);
            resolve(res);
          }
        );
    });
    return promise;
  }

  GetFacebookQuery(token: string, id: string, query: string)
  {
    let promise = new Promise((resolve, reject) => {
      let apiURL = `${this.baseUrl}/${id}?${query}&access_token=${token}`;
      this.http.get(apiURL)
        .toPromise()
        .then(
          res => { // Success
            console.log(res);
            resolve(res);
          }
        );
    });
    return promise;
  }
  


}



   // this.http.get("https://graph.facebook.com/me?access_token=" + token)


// WEBPACK FOOTER //
// C:/Users/apostolos/Documents/globalrank/src/app/http-engine.service.ts